import { post, postFile, postExFile } from "@utils/httpUtil";
export function questionnaireDelete(data, config) {
  return post("/baseQuestionnaire/delete", data, config);
}
export function getCatalog(data, config) {
  return post("/baseQuestionnaire/getCatalog", data, config);
}
export function getCreatorList(data, config) {
  return post("/baseQuestionnaire/getCreatorList", data, config);
}
export function getDetail(data, config) {
  return post("/baseQuestionnaire/getDetail", data, config);
}
export function getList(data, config) {
  return post("/baseQuestionnaire/getList", data, config);
}
export function getPage(data, config) {
  return post("/baseQuestionnaire/getPage", data, config);
}
export function save(data, config) {
  return post("/baseQuestionnaire/save", data, config);
}
export function importBaseAnswerItem(data, config) {
  return postFile("/baseQuestionnaire/import/importBaseAnswerItem", data, config);
}
export function baseQuestionnaireItem(data, config) {
  return postFile("/baseQuestionnaire/import/baseQuestionnaireItem", data, config);
}
export function exportErrorData(data, config) {
  return postExFile("/baseQuestionnaire/export/errorData", data, config);
}
export function exportQuestionBank(data, config) {
  return postExFile("/baseQuestionnaire/export", data, config);
}
export function getQuestionCreateList(data, config) {
  return post("/baseQuestionnaire/getQuestionCreateList", data, config);
}